import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {FitImagesToFrameParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type CommonImageFetchParams, fetchFittingImages} from './requests'
import {ERRORS} from '../constants'

export const fitImagesToFrame = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: FitImagesToFrameParams
): Promise<void> => {
    return generateAndInjectImages<CommonImageFetchParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url
        }),
        fetchFittingImages,
        {userRequestInfo, onSuccess, onError, caller: 'fitImagesToFrame', errorType: ERRORS.IMAGES.FIT_IMAGES_TO_FRAME}
    )
}
